import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../hooks/theme"


const useStyles = () => {
  const { colors } = useContextState()
  const { breakpoints } = useTheme()
  return {
    title: {
      flexGrow: 1,
      fontSize: '20px',
      fontWeight: '500',
    },
    containerDate: {
      marginTop: 1
    },
    containerFilter: {
      display: 'flex',
      gap: 2,
      position: 'relative',
    },
    clean: {
      fontSize: '2rem',
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    hide: {
      visibility: 'hidden',
    },
    drawerfilter: {
      height: '40px',
      width: '40px'
    },
    section: {
      marginBottom: '32px',
    },
    headerTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }
}

export { useStyles }
